import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import React from 'react';

import { TOP_BAR_HEIGHT } from './constants';
import { TopBarAccountMenu } from './top-bar-account-menu';

import { getDesignTokens } from '~/client/components/base/core';
import useLeftNavContext from '~/client/components/base/left-nav/left-nav-context';

const StyledAppBar = styled(AppBar)(({ theme }) => {
  const tokens = getDesignTokens(
    theme.palette.mode === 'dark' ? 'dark' : 'light'
  );
  return {
    backgroundColor: `${tokens.nav.sidebarBg} !important`,
    color: tokens.nav.itemTextOnDark,
    boxShadow: 'none',
    borderBottom: `1px solid ${tokens.nav.sidebarDivider}`,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: theme.zIndex.appBar + 1,
    '@media print': {
      display: 'none',
    },
  };
});

export { TOP_BAR_HEIGHT };

const StyledToolbar = styled(Toolbar)(({ theme }) => {
  const tokens = getDesignTokens(
    theme.palette.mode === 'dark' ? 'dark' : 'light'
  );
  return {
    minHeight: TOP_BAR_HEIGHT,
    height: TOP_BAR_HEIGHT,
    maxHeight: TOP_BAR_HEIGHT,
    paddingLeft: 12,
    paddingRight: 12,
    backgroundColor: `${tokens.nav.sidebarBg} !important`,
    overflow: 'hidden',
  };
});

interface TopBarProps {
  children?: React.ReactNode;
}

const TopBar: React.FC<TopBarProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { toggleMobileOpen } = useLeftNavContext();

  const tokens = getDesignTokens(
    theme.palette.mode === 'dark' ? 'dark' : 'light'
  );

  const showTopBar = isMobile;

  if (!showTopBar) {
    return null;
  }

  const handleMenuClick = () => {
    toggleMobileOpen();
  };

  return (
    <StyledAppBar
      position="fixed"
      color="inherit"
      data-feedback-id="app-header"
    >
      <StyledToolbar>
        <IconButton
          edge="start"
          aria-label="open navigation menu"
          onClick={handleMenuClick}
          sx={{ mr: 0.5, color: tokens.nav.itemTextOnDark, flexShrink: 0 }}
        >
          <MenuIcon style={{ fontSize: 24 }} />
        </IconButton>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          {children}
        </Box>
        <Box sx={{ flexShrink: 0 }}>
          <TopBarAccountMenu iconColor={tokens.nav.itemTextOnDark} />
        </Box>
      </StyledToolbar>
    </StyledAppBar>
  );
};

export default TopBar;
